let baseUrl = '';
if (process.env.NODE_ENV === 'development') {
  // baseUrl = 'http://yapi.zc0901.com/mock/27/api/web/v1';
  baseUrl = 'http://dci.zc0901.com/api/web/v1'; 
} else if (process.env.NODE_ENV === 'production') {
  baseUrl = 'https://www.dcihome.com.cn/api/web/v1/';
  // baseUrl = 'http://dci.zc0901.com/api/web/v1';;
}

export {
  baseUrl
}
